import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/spot-of-the-week/help')({})
